import { ContractAction, ContractActionTypes, ContractState } from "./types";

const initialState: ContractState = {
  id: "",
  name: "",
  regDate: null,
  deliveryDate: null,
  expired: 0,
  customerFirstName: "",
  customerLastName: "",
  customerId: "",
  customerPhone: "",
  customerAlternatePhone: "",
  customerEmail: "",
  customerAddress1: "",
  customerAddress2: "",
  customerCity: "",
  customerState: "",
  customerZip: "",
  deliveryAddress1: "",
  deliveryAddress2: "",
  deliveryCity: "",
  deliveryState: "",
  deliveryZip: "",
  storeName: "",
  salesPerson: "",
  storeAddress1: "",
  storeCity: "",
  storeState: "",
  storeZip: "",
  invoiceNumber: "",
  totalPrice: 0,
  dealerSku: "",
  warrantyProgram: "",
  warrantyProgramPrice: 0,
  purchaseDate: null,
  expirationDate: null,
  status: "",
  lineItems: [],
  calculatedRefundAmount: null,
  isActiveClaim: false,
  contactId: "",
  TCFileLink: null,
};

export const contractReducer = (
  state: ContractState = initialState,
  action: ContractActionTypes
): ContractState => {
  switch (action.type) {
    case ContractAction.SET_CONTRACT_RECORD: {
      return {
        ...state,
        ...(action.payload || {}),
      };
    }

    case ContractAction.CLEAN_UP: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};
